import React from 'react';
import { DialogProps } from '@radix-ui/react-dialog';

import {
  Modal,
  ModalContent,
  ModalTitle,
  ModalDescription,
  ModalFooter
} from 'epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';

export interface UnsavedChangesConfirmationModalProps extends DialogProps {
  onDiscard: () => void;
  onCancel: () => void;
}

export const UnsavedChangesConfirmationModal: React.FC<UnsavedChangesConfirmationModalProps> = ({
  onDiscard,
  onCancel,
  ...modalProps
}): JSX.Element => {
  return (
    <Modal {...modalProps}>
      <ModalContent showCloseButton={false} size="sm" className="tw-gap-5">
        <ModalTitle>Discard changes?</ModalTitle>
        <ModalDescription className="tw-mt-0">
          Changes will be lost if you leave this page. Stay on the page to keep your changes.
        </ModalDescription>
        <ModalFooter className="tw-mt-0 tw-justify-end tw-gap-3">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className="tw-rounded-lg"
            onClick={onCancel}
          >
            Stay on page
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            className="tw-rounded-lg"
            onClick={onDiscard}
          >
            Discard
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
